import styled from "styled-components";

export const Heading = styled.p`
  font-size: 26px;
  color: var(--blue-secondary);
  margin-bottom: 1em;
  font-family: "Gabarito", sans-serif !important;
`;
